import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";

import { useDispatch, useSelector, connect } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container, Paper, Typography, Grid, Box } from "@material-ui/core";
import { Card, Form, Button, Modal } from "react-bootstrap";
import { makeStyles } from "@material-ui/styles";
import { deleteCookieCredentials, setLocalStorageObject, getLocalStorageObject, isProPlan } from "../../../util/helper"
import { strategyGroupingAction, WindowScreenAction, updateInstrumentConfigAction, getInstrumentConfigAction, getBrokerConfigAction, updateBrokerConfigAction } from "../../../redux/actions/brokerAction";
import AppContext from "../../../context/Context";
import Chip from '@mui/material/Chip';
import { Radio, InputNumber, Switch, Checkbox, Tooltip, Modal as AntModal } from "antd";
import PlusMinQty from "../../utilities/PlusMinQty";
import LoderCom from "../../common/Loder";
import UseDebounce from "../../common/useDebounce";
import SettingsIcon from '@mui/icons-material/Settings';
import LegRiskModal from "../common/LegRiskModal";
import StrategyRiskModal from "../common/StrategyRiskModal";
import { helpText } from "../../../util/helpText";
import { Info } from "lucide-react";
const defProduct = ['NRML', 'MIS'];
const defOrderType = ['Mkt protect', 'Limit at LTP', 'Limit with buffer'];
const exitOrderType = ['Mkt protect', 'MARKET'];
const defValidity = ['DAY', 'IOC'];
const defSLTP = ['SL-L', 'SL-M'];
const defLimitTimeout = ['Do Nothing', 'Convert to Market Order', 'Cancel'];
const defExecutionMode = ['parallel', 'sequential'];

const useStyles = makeStyles((theme) => ({
  textClass: {
    margin: "1px 4px",
    padding: "1px 4px",
    fontSize: "11px",
    fontWeight: "bold",
  },
  sectionHeading: {
    fontWeight: "bold",
    marginBottom: "10px",
    paddingBottom: "8px",
    fontSize: "14px",
  },
  sectionHeadingDark: {
    borderBottom: "2px solid #344050",
  },
  sectionHeadingLight: {
    borderBottom: "2px solid #D9D9D9",
  },
  sectionContent: {
    display: "grid",
    gap: "10px",
    gridTemplateColumns: "1fr 1fr"
  },
  sectionContentSingle: {
    display: "grid",
    gap: "10px",
    gridTemplateColumns: "1fr"
  },
  modalDropdownItem: {
    padding: "6px",
    display: "flex",
    whiteSpace: "nowrap",
    alignItems: "center"
  },
}));
export const initial = {
  product: "MIS",
  orderType: "Mkt protect",
  exitOrderType: "Mkt protect",
  validity: "DAY",
  marketProtect: 5,
  exitmarketProtect: 5,
  marketBuffer: 1,
  exitmarketBuffer: 1,
  freezeQty: 1,
  orderQty: 1,
  leftWindow: true,
  legRms: null,
  strategyRms: null,
  maxLoss: null,
  maxProfit: null,
  autoSquareOffTime: "15:18",
  useBrokerSlTp: false,
  brokerSlTpOrderType: "SL-L",
  brokerSlTpOrderPercent: 1,
  nConsecutiveTicks: 2,
  isUpdate: false,
  isBroker: false,
  limitOrderTimeoutAction: 0,
  limitOrderTimeoutDuration: 1,
  applyRmsToSellOnly: false,
  enableOrderWindow: false,
  exitExecutionMode: "sequential",
  exitBuySellDelaySeconds: 3,
  entryExecutionMode: "sequential",
  entryBuySellDelaySeconds: 3,
  allOrNothingEntry: false,
  allOrNothingExit: false,
};


const dropdownConfig = [
  { id: 'product', label: 'Product', visible: true },
  { id: 'entryOrderType', label: 'Entry Order Type', visible: true },
  { id: 'entryMarketProtect', label: 'Entry Mkt Protect %', visible: true },
  { id: 'entryMarketBuffer', label: 'Entry Limit Buffer %', visible: true },
  { id: 'maxLot', label: 'Max Lot', visible: true },
  { id: 'orderLot', label: 'Order (Lot)', visible: true },
  { id: 'validity', label: 'Validity', visible: true },
  { id: 'rmsMaxLoss', label: 'RMS MaxLoss', visible: true },
  { id: 'rmsMaxProfit', label: 'RMS MaxProfit', visible: true },
  { id: 'autoSquareOff', label: 'Auto Square Off', visible: true },
  { id: 'exitOrderType', label: 'Exit Order Type', visible: true },
  { id: 'exitMarketProtect', label: 'Exit Mkt Protect %', visible: true },
  { id: 'exitMarketBuffer', label: 'Exit Market Buffer %', visible: true },
  // { id: 'sendSlToBroker', label: 'Send SL to Broker', visible: true },
  { id: 'brokerOrderType', label: 'Broker Order Type', visible: true },
  { id: 'triggerPriceBuffer', label: 'Trigger Price Buffer', visible: true },
  { id: 'waitXTicks', label: 'Wait X ticks', visible: true },
  { id: 'strategyGrouping', label: 'Strategy Grouping', visible: true },
  { id: 'limitTimeoutAction', label: 'Limit Timeout Action', visible: true },
  { id: 'limitTimeoutSecs', label: 'Limit Timeout Secs', visible: true },
  { id: 'applyRmsToSellOnly', label: 'Apply RMS to Sell Orders Only', visible: true },
  { id: 'enableOrderWindow', label: 'Enable Order Window', visible: true },
  { id: 'entryExecutionMode', label: 'Entry Execution Mode', visible: true },
  { id: 'entryBuySellDelaySeconds', label: 'Entry Delay (Secs)', visible: true },
  { id: 'exitExecutionMode', label: 'Exit Execution Mode', visible: true },
  { id: 'exitBuySellDelaySeconds', label: 'Exit Delay (Secs)', visible: true },
  { id: 'allOrNothingEntry', label: 'Exit on Margin Error(Entry)', visible: true },
  { id: 'allOrNothingExit', label: 'Exit on Margin Error(Exit)', visible: true },
];


let localStorageObj = getLocalStorageObject("global-bottom-header") || {};
let localStorageScreenObj = getLocalStorageObject("window-screen") || {
  screen: {},
};
let localStorageObjOther = getLocalStorageObject("global-bottom-other") || {
  strategygrouping: true
};
let localStorageDropdownConfig = getLocalStorageObject("dropdown-visibility-config") || {
  dropdowns: dropdownConfig
};

const HeaderDropdown = ({ getInputValues, selectInstrument, info, chartFilterWrap }) => {

  const {
    config: { isDark },
  } = useContext(AppContext);

  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const windowScreen = useSelector((state) => state.windowScreen);
  const instrumentConfig = useSelector((state) => state.instrumentConfig.instrumentConfig);
  const suscriptionStatus = useSelector((state) => state?.packages?.suscriptionStatus);

  const [formData, setFormData] = useState({
    ...initial,
    enableOrderWindow: getLocalStorageObject("global-bottom-other")?.enableOrderWindow || false
  });
  const [priceType, setpriceType] = useState(2);
  const [isLoder, setLoder] = useState(true);
  const debounceValue = UseDebounce(formData, 1000);
  const [isModify, setisModify] = useState("");
  const [isError, seterror] = useState("");
  const [strategygrouping, setstrategygrouping] = useState(true);
  const [showDropdownModal, setShowDropdownModal] = useState(false);
  const [dropdownVisibility, setDropdownVisibility] = useState(() => {
    const stored = getLocalStorageObject("dropdown-visibility-config")?.dropdowns;
    if (!stored) return dropdownConfig;
    return dropdownConfig.map(def => {
      const found = stored.find(s => s.id === def.id);
      return found ? { ...def, visible: found.visible } : def;
    });
  });
  const [tempDropdownVisibility, setTempDropdownVisibility] = useState([]);
  const [showLegRisk, setShowLegRisk] = useState(false);
  const [showStrategyRisk, setShowStrategyRisk] = useState(false);
  const [showSlInfoModal, setShowSlInfoModal] = useState(false);
  const [showMaxLotInfoModal, setShowMaxLotInfoModal] = useState(false);
  useEffect(() => {

    if (info && info.selectedBroker) {
      const val = getLocalStorageObject("global-bottom-other");
      if (val) {
        var isVal = val.strategygrouping;
        setstrategygrouping(isVal);
        dispatch(strategyGroupingAction(val))
      } else {
        var isVal = true;
        setLocalStorageObject(
          "global-bottom-other",
          'strategygrouping',
          isVal,
          localStorageObjOther
        );
        dispatch(strategyGroupingAction(getLocalStorageObject("global-bottom-other")))
      }

    }
  }, [info, suscriptionStatus])




  useEffect(() => {

    if (instrumentConfig && Object.keys(instrumentConfig)) {
      const value = {
        ...formData,
        product: instrumentConfig.entryProduct,
        orderType: instrumentConfig.entryOrderType,
        exitOrderType: instrumentConfig.exitOrderType === "LIMIT" ? "Mkt protect" : instrumentConfig.exitOrderType,
        marketProtect: instrumentConfig.entryOrderMarketPercent,
        marketBuffer: instrumentConfig.entryOrderLimitPercent,
        exitmarketProtect: instrumentConfig.exitOrderLimitPercent,
        freezeQty: instrumentConfig.maxLotsPerOrder,
        orderQty: instrumentConfig.entryOrderLots,
        legRms: instrumentConfig.legRms || null,
        strategyRms: instrumentConfig.strategyRms || null,
        autoSquareOffTime: instrumentConfig.autoSquareOffTime,
        useBrokerSlTp: instrumentConfig.useBrokerSlTp,
        applyRmsToSellOnly: instrumentConfig.applyRmsToSellOnly || false,
        maxLoss: instrumentConfig.maxLoss || null,
        maxProfit: instrumentConfig.maxProfit || null
      };
      setFormData(value);
    }


  }, [instrumentConfig])

  useEffect(() => {


    async function getConfig(brokerId, instrumentToken) {
      const data = await dispatch(getInstrumentConfigAction(brokerId, instrumentToken));

      var value = {};
      if (data?.status) {
        value = {
          ...formData,
          product: data.data.entryProduct,
          orderType: data.data.entryOrderType,
          exitOrderType: data.data.exitOrderType === "LIMIT" ? "Mkt protect" : data.data.exitOrderType,
          marketProtect: data.data.entryOrderMarketPercent,
          marketBuffer: data.data.entryOrderLimitPercent,
          exitmarketProtect: data.data.exitOrderLimitPercent,
          freezeQty: data.data.maxLotsPerOrder,
          orderQty: data.data.entryOrderLots,
          legRms: data.data.legRms || null,
          strategyRms: data.data.strategyRms || null,
          autoSquareOffTime: data.data.autoSquareOffTime,
          useBrokerSlTp: data.data.useBrokerSlTp,
          applyRmsToSellOnly: data.data.applyRmsToSellOnly || false,
          maxLoss: data.data.maxLoss || null,
          maxProfit: data.data.maxProfit || null,
          limitOrderTimeoutAction: data.data.limitOrderTimeoutAction,
          limitOrderTimeoutDuration: data.data.limitOrderTimeoutDuration,
          entryExecutionMode: data.data.entryExecutionMode || "sequential",
          entryBuySellDelaySeconds: data.data.entryBuySellDelaySeconds || 3,
          exitExecutionMode: data.data.exitExecutionMode || "sequential",
          exitBuySellDelaySeconds: data.data.exitBuySellDelaySeconds || 3,
          allOrNothingEntry: data.data.allOrNothingEntry || false,
          allOrNothingExit: data.data.allOrNothingExit || false,
        };

        if (data.data.config === false) {
          const param = {
            "autoSquareOffTime": formData.autoSquareOffTime,
            "useBrokerSlTp": formData.useBrokerSlTp,
            "applyRmsToSellOnly": formData.applyRmsToSellOnly,
            "maxLoss": formData.maxLoss ? formData.maxLoss : null,
            "maxProfit": formData.maxProfit ? formData.maxProfit : null,
            "nConsecutiveTicks": parseFloat(formData.nConsecutiveTicks),
            "brokerSlTpOrderType": formData.brokerSlTpOrderType === "SL-L" ? "SL" : formData.brokerSlTpOrderType,
            "brokerSlTpOrderPercent": parseFloat(formData.brokerSlTpOrderPercent),
            "limitOrderTimeoutAction": parseFloat(formData.limitOrderTimeoutAction),
            "limitOrderTimeoutDuration": parseFloat(formData.limitOrderTimeoutDuration),
            "entryExecutionMode": formData.entryExecutionMode,
            "entryBuySellDelaySeconds": parseFloat(formData.entryBuySellDelaySeconds),
            "exitExecutionMode": formData.exitExecutionMode,
            "exitBuySellDelaySeconds": parseFloat(formData.exitBuySellDelaySeconds),
            "allOrNothingEntry": formData.allOrNothingEntry,
            "allOrNothingExit": formData.allOrNothingExit
          };
          updateBrokerConfig(param);
        }
        setFormData(value);
        getInputValues(value, '0');
      } else {
        value = {
          ...formData,
          product: "MIS",
          orderType: "Mkt protect",
          exitOrderType: "Mkt protect",
          marketProtect: 5,
          exitmarketProtect: 5,
          freezeQty: !info.volumeFreeze ? 50 : info.volumeFreeze / info.lotSize,
          orderQty: 1,
          legRms: null,
          strategyRms: null,
          autoSquareOffTime: "15:18",
          useBrokerSlTp: false,
          applyRmsToSellOnly: false,
          maxLoss: "",
          maxProfit: "",
          isUpdate: true
        };
        setFormData(value);
        getInputValues(value);
      }
      setLoder(false)
      setLocalStorageObject(
        "global-bottom-header",
        selectInstrument,
        value,
        localStorageObj
      );

    }


    if (info.broker.id && info.instrumentToken && info.lotSize) {
      getConfig(info.broker.id, info.instrumentToken);
    }


  }, [info]);


  useEffect(() => {


    if (debounceValue.isUpdate) {
      const param = {
        "entryProduct": formData.product,
        "maxLotsPerOrder": parseFloat(formData.freezeQty),
        "entryOrderType": formData.orderType,
        "entryOrderLimitPercent": formData.orderType === "Limit with buffer" ? parseFloat(formData.marketBuffer) : null,
        "entryOrderMarketPercent": formData.orderType === "Mkt protect" ? parseFloat(formData.marketProtect) : null,
        "exitOrderType": formData.exitOrderType === "Mkt protect" ? "LIMIT" : formData.exitOrderType,
        "exitOrderLimitPercent": formData.exitOrderType === "MARKET" ? null : parseFloat(formData.exitmarketProtect),
        "entryOrderLots": parseFloat(formData.orderQty),
        "legRms": formData.legRms,
        "strategyRms": formData.strategyRms,
      };

      if (info.broker.id && info.instrumentToken) {
        dispatch(updateInstrumentConfigAction(info.broker.id, info.instrumentToken, param));
        const value = {
          ...formData,
          isUpdate: false
        };
        setFormData(value);
      }

    }

    if (debounceValue.isBroker) {

      const param = {
        "autoSquareOffTime": formData.autoSquareOffTime,
        "useBrokerSlTp": formData.useBrokerSlTp,
        "applyRmsToSellOnly": formData.applyRmsToSellOnly,
        "maxLoss": formData.maxLoss ? formData.maxLoss : null,
        "maxProfit": formData.maxProfit ? formData.maxProfit : null,
        "nConsecutiveTicks": parseFloat(formData.nConsecutiveTicks),
        "brokerSlTpOrderType": formData.brokerSlTpOrderType === "SL-L" ? "SL" : formData.brokerSlTpOrderType,
        "brokerSlTpOrderPercent": parseFloat(formData.brokerSlTpOrderPercent),
        "limitOrderTimeoutAction": parseFloat(formData.limitOrderTimeoutAction),
        "limitOrderTimeoutDuration": parseFloat(formData.limitOrderTimeoutDuration),
        "entryExecutionMode": formData.entryExecutionMode,
        "entryBuySellDelaySeconds": formData.entryExecutionMode === "parallel" ? null : parseFloat(formData.entryBuySellDelaySeconds),
        "exitExecutionMode": formData.exitExecutionMode,
        "exitBuySellDelaySeconds": formData.exitExecutionMode === "parallel" ? null : parseFloat(formData.exitBuySellDelaySeconds),
        "allOrNothingEntry": formData.allOrNothingEntry,
        "allOrNothingExit": formData.allOrNothingExit
      };
      updateBrokerConfig(param);
    }

  }, [debounceValue]);

  const handleFieldChange = (value, name) => {

    if (value === 0 && name !== "stopLossPrice" && name !== "targetPrice" && name !== "marketProtect" && name !== "exitmarketProtect") {
      return;
    }

    // Convert 0 to blank (null) for SL/TP
    if ((name === "stopLossPrice" || name === "targetPrice") && value == 0) {
      value = null;
    }

    const formvalue = {
      ...formData,
      [name]: value,
      isUpdate: true,
      isBroker: false,

    };
    setFormData(formvalue);
    getInputValues(formvalue);
    setLocalStorageObject(
      "global-bottom-header",
      selectInstrument,
      formvalue,
      localStorageObj
    );
  };

  const textColor = () => {
    return isDark ? "#9da9bb" : "#1890ff";
  }

  const chipColor = () => {
    return isDark ? "#0b1727" : "white"
  }




  const updateBrokerConfig = async (param) => {

    const data = await dispatch(updateBrokerConfigAction(info.broker.id, param));

  }
  const handleCellHover = (type) => {

    setisModify(type)

  }
  const handleCellHoverLeave = (type) => {
    setisModify("")
  }

  const handleFieldBCChange = (value, name) => {
    if (name === "autoSquareOffTime" && value) {
      var shours = value.split(':')[0];

      if (parseInt(shours) >= 9 && parseInt(shours) <= 15) {
        value = value.split(":")[0] + ':' + value.split(":")[1]
      } else {
        return
      }
    }
    // Convert 0 to blank (null) for RMS fields
    if ((name === "maxLoss" || name === "maxProfit") && value == 0) {
      value = null;
    }
    const formvalue = {
      ...formData,
      [name]: value,
      isUpdate: false,
      isBroker: true,
    };

    setFormData(formvalue);
    getInputValues(formvalue);
  }

  const handleSendSlToBrokerChange = (checked) => {
    if (checked) {
      setShowSlInfoModal(true);
    } else {
      handleFieldBCChange(checked, "useBrokerSlTp");
    }
  };

  const handleSlInfoModalOk = () => {
    // User acknowledged the info, now enable the feature
    handleFieldBCChange(true, "useBrokerSlTp");
    setShowSlInfoModal(false);
  };

  const handleSlInfoModalCancel = () => {
    // User cancelled, don't enable the feature
    setShowSlInfoModal(false);
  };






  const setTrailingSLValueType = (vt) => {
    const updated = { ...formData, trailingSLValueType: vt, isUpdate: false, isBroker: true };
    setFormData(updated);
    getInputValues(updated);
    setLocalStorageObject(
      "global-bottom-header",
      selectInstrument,
      updated,
      localStorageObj
    );
  };

  const cycleTrailingSLType = () => {
    const next = (parseInt(formData.trailingSLValueType ?? 0) % 2) + 1;
    setTrailingSLValueType(next);
  };

  // Dropdown visibility functions
  const openDropdownModal = () => {
    setTempDropdownVisibility([...dropdownVisibility]);
    setShowDropdownModal(true);
  };

  const handleDropdownVisibilityChange = (dropdownId, checked) => {
    const updatedDropdowns = tempDropdownVisibility.map(dropdown =>
      dropdown.id === dropdownId ? { ...dropdown, visible: checked } : dropdown
    );
    setTempDropdownVisibility(updatedDropdowns);
  };

  const handleSelectAll = () => {
    const updatedDropdowns = tempDropdownVisibility.map(dropdown => ({ ...dropdown, visible: true }));
    setTempDropdownVisibility(updatedDropdowns);
  };

  const handleDeselectAll = () => {
    const updatedDropdowns = tempDropdownVisibility.map(dropdown => ({ ...dropdown, visible: false }));
    setTempDropdownVisibility(updatedDropdowns);
  };

  const saveDropdownConfig = () => {
    setDropdownVisibility([...tempDropdownVisibility]);
    setLocalStorageObject(
      "dropdown-visibility-config",
      'dropdowns',
      tempDropdownVisibility,
      localStorageDropdownConfig
    );
    setShowDropdownModal(false);
  };

  const cancelDropdownConfig = () => {
    setTempDropdownVisibility([]);
    setShowDropdownModal(false);
  };

  const isDropdownVisible = (dropdownId) => {
    const dropdown = dropdownVisibility.find(d => d.id === dropdownId);
    return dropdown ? dropdown.visible : true;
  };

  const handleLegRiskSave = ({ formData: modalForm }) => {
    const legRms = modalForm.legRms;

    const updated = {
      ...formData,
      legRms: legRms,
      isUpdate: true
    };
    setFormData(updated);
    getInputValues(updated);
    setLocalStorageObject(
      "global-bottom-header",
      selectInstrument,
      updated,
      localStorageObj
    );
    setShowLegRisk(false);
  };

  const handleStrategyRiskSave = ({ formData: modalForm }) => {
    const strategyRms = modalForm.strategyRms;

    const updated = {
      ...formData,
      strategyRms: strategyRms,
      isUpdate: true
    };
    setFormData(updated);
    getInputValues(updated);
    setLocalStorageObject(
      "global-bottom-header",
      selectInstrument,
      updated,
      localStorageObj
    );
    setShowStrategyRisk(false);
  };

  return (
    <div style={{ paddingInline: "6px" }} className="order-window-body top-bottom-header" ref={chartFilterWrap}>
      {isLoder && <LoderCom />}
      <Card.Body className="p-0">

        <Grid
          container
          item
          style={{ gap: "10px" }}
        >


          <Grid item>
            <Chip
              label={"Option Chain"}
              style={{
                background: windowScreen?.leftWindow ? "#1890ff" : chipColor(),
                color: windowScreen?.leftWindow ? "white" : textColor(),
                borderRadius: "0.25rem",
                border: windowScreen?.leftWindow ? "none" : "1px solid 1890ff",
                height: "29px",

              }}

              onClick={() => {
                var screen = windowScreen;
                screen.leftWindow = !windowScreen?.leftWindow;
                dispatch(WindowScreenAction(screen));
                setLocalStorageObject(
                  "window-screen",
                  'screen',
                  screen,
                  localStorageScreenObj
                );
              }}
              className="chip"
            />
          </Grid>

          <Grid item>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={openDropdownModal}
              className="dropdown-settings"
              title="Configure Dropdown Visibility"
            >
              <SettingsIcon fontSize="small" />
            </Button>
          </Grid>

          {isDropdownVisible('product') && (
            <Grid item>

              <Form.Group className="form-group">
                <label className="form-label">
                  Product
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.product}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Select style={{ width: "80px" }} aria-label="Default select example" name="product" value={formData.product || "MIS"} onChange={(e) => handleFieldChange(e.target.value, "product")}>
                  {defProduct.map((data, index) => {
                    return (
                      <option value={data} key={index}>{data}</option>
                    )
                  })
                  }
                </Form.Select>
              </Form.Group>
            </Grid>
          )}
          {isDropdownVisible('entryOrderType') && (
            <Grid item>
              <Form.Group className="form-group">
                <label className="form-label">
                  Entry Order Type
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.orderType}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Select aria-label="Default select example" name="orderType" value={formData.orderType || "Mkt protect"} onChange={(e) => handleFieldChange(e.target.value, "orderType")}>
                  {defOrderType.map((data, index) => {
                    return (
                      <option value={data} key={index}>{data}</option>
                    )
                  })
                  }
                </Form.Select>
              </Form.Group>

            </Grid>
          )}

          {formData.orderType === "Mkt protect" && (isDropdownVisible('entryMarketProtect') || isDropdownVisible('entryOrderType')) && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("MP")}
              onMouseEnter={(e) => handleCellHover("MP")}
            //onClick={() => editField("MP")}

            >
              <Form.Group className="form-group">
                <label className="form-label">
                  Entry Mkt Protect %
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.marketProtect}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>

                <PlusMinQty
                  qtyClick={(qty, value) => {
                    handleFieldChange(qty, "marketProtect")
                  }}
                  filterValue={formData.marketProtect}
                  name={"marketProtect"}
                  min={0}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />

              </Form.Group>

            </Grid>
          )}

          {formData.orderType === "Limit with buffer" && (isDropdownVisible('entryMarketBuffer') || isDropdownVisible('entryOrderType')) && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("MB")}
              onMouseEnter={(e) => handleCellHover("MB")}
            >
              <Form.Group className="form-group">
                <label className="form-label">
                  Entry Limit Buffer %
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.limitWithBuffer}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>

                <PlusMinQty
                  qtyClick={(qty, value) => {
                    handleFieldChange(qty, "marketBuffer")
                  }}
                  filterValue={formData.marketBuffer}
                  name={"marketBuffer"}
                  min={1}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />

              </Form.Group>

            </Grid>
          )}
          {isDropdownVisible('maxLot') && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("ML")}
              onMouseEnter={(e) => handleCellHover("ML")}
            >
              <Form.Group className="form-group">
                <label className="form-label">Max Lot</label>
                <label className="form-label" style={{ marginBottom: "0" }}> <span>Qty : {info.lotSize && formData.freezeQty ? formData.freezeQty * info.lotSize : 0}</span>
                <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.maxQtyPerOrder}>
                  <Info size={12}
                    className="info-icon"
                    onClick={() => setShowMaxLotInfoModal(true)}
                  />
                </Tooltip>
                </label>
                {/* <Form.Control type="number" placeholder="" step="1" name="freezeQty" min={1} value={formData.freezeQty} onChange={handleFieldChange}/> */}
                <PlusMinQty
                  qtyClick={(qty, value) => {
                    const orderQty = parseFloat(formData.orderQty) || 0;
                    const maxLot = parseFloat(qty) || 0;
                    if (maxLot > 0 && orderQty > 0) {
                      const numOrders = Math.ceil(orderQty / maxLot);
                      if (numOrders > 5) {
                        setShowMaxLotInfoModal(true);
                      }
                    }

                    if (info.volumeFreeze == 0) {
                      if ((qty * info.lotSize) > 50 * info.lotSize) {
                        return false
                      } else {
                        handleFieldChange(qty, "freezeQty")
                      }
                    } else {
                      if ((qty * info.lotSize) > info.volumeFreeze) {
                        return
                      } else {
                        handleFieldChange(qty, "freezeQty")
                      }
                    }
                  }}
                  filterValue={formData.freezeQty}
                  name={"freezeQty"}
                  min={1}
                  step={1}
                  max={info.volumeFreeze == 0 ? 50 : info.volumeFreeze / info.lotSize}
                  isModify={isModify}
                  page={"header"}
                />
              </Form.Group>


            </Grid>
          )}
          {isDropdownVisible('orderLot') && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("ML")}
              onMouseEnter={(e) => handleCellHover("ML")}
            >
              <Form.Group className="form-group">
                <label className="form-label">
                  Order (Lot)
                </label>
                <label className="form-label"> <span>Qty: {info.lotSize ? info.lotSize * formData.orderQty : 0}</span>
                <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.orderQty}>
                  <Info size={12} className="info-icon" />
                </Tooltip>
                </label>
                {/* <Form.Control type="number" placeholder="" step="1" name="orderQty" min={1} value={formData.orderQty} onChange={handleFieldChange}/> */}
                <PlusMinQty
                  qtyClick={(qty, value) => {
                    if (qty > 0) {
                      const orderQty = parseFloat(qty) || 0;
                      const maxLot = parseFloat(formData.freezeQty) || 0;
                      if (maxLot > 0 && orderQty > 0) {
                        const numOrders = Math.ceil(orderQty / maxLot);
                        if (numOrders > 5) {
                          setShowMaxLotInfoModal(true);
                        }
                      }
                      handleFieldChange(qty, "orderQty")
                    }
                  }}
                  filterValue={formData.orderQty}
                  name={"orderQty"}
                  min={1}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />
              </Form.Group>

            </Grid>
          )}
          {isDropdownVisible('validity') && (
            <Grid item>
              <Form.Group className="form-group">
                <label className="form-label">
                  Validity
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.validity}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Select className="w-80px" aria-label="Default select example" name="validity" value={formData.validity || "DAY"} onChange={(e) => handleFieldChange(e.target.value, "validity")}>
                  {defValidity.map((data, index) => {
                    return (
                      <option value={data} key={index}>{data}</option>
                    )
                  })
                  }
                </Form.Select>
              </Form.Group>

            </Grid>
          )}
          {/* Replace SL/TP inputs with risk setting buttons */}
          <Grid item>
            <Button className="config-btn" variant="outline-primary" size="sm" onClick={() => setShowLegRisk(true)}>
              Default Leg Risk Settings
              <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.defaultLegRisk}>
                <Info size={12} className="info-icon" />
              </Tooltip>
            </Button>
          </Grid>
          <Grid item>
            <Button className="config-btn" variant="outline-primary" size="sm" onClick={() => setShowStrategyRisk(true)}>
              Default  Strategy Risk Settings
              <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.defaultStrategyRisk}>
                <Info size={12} className="info-icon" />
              </Tooltip>
            </Button>
          </Grid>
          {isDropdownVisible('rmsMaxLoss') && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("ML")}
              onMouseEnter={(e) => handleCellHover("ML")}
              className="text-center">
              <Form.Group className="form-group   " >
                <label className="form-label">
                  RMS MaxLoss
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.rmsMaxLoss}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <PlusMinQty
                  qtyClick={(qty, value) => {
                    handleFieldBCChange(parseFloat(qty), "maxLoss")
                  }}
                  filterValue={formData.maxLoss ?? ""}
                  name={"maxLoss"}
                  min={null}
                  step={null}
                  isModify={isModify}
                  page={"header"}
                />
              </Form.Group>
            </Grid>
          )}

          {isDropdownVisible('rmsMaxProfit') && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("ML")}
              onMouseEnter={(e) => handleCellHover("ML")}
              className="text-center">
              <Form.Group className="form-group  "  >
                <label className="form-label">
                  RMS MaxProfit
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.rmsMaxProfit}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>

                <PlusMinQty
                  qtyClick={(qty, value) => {
                    handleFieldBCChange(parseFloat(qty), "maxProfit")
                  }}
                  filterValue={formData.maxProfit ?? ""}
                  name={"maxProfit"}
                  min={0}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />

              </Form.Group>
            </Grid>
          )}

          {isDropdownVisible('autoSquareOff') && (
            <Grid item className="text-center">
              <Form.Group className="form-group  ">
                <label className="form-label">
                  Auto Square Off
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.autoSquareOff}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Control
                  type="time"
                  name="autoSquareOffTime"
                  value={formData.autoSquareOffTime || "15:20"}
                  onChange={(e) => handleFieldBCChange(e.target.value, "autoSquareOffTime")}
                  style={{
                    width: "94px",
                    paddingRight: "0",
                    paddingLeft: "10px"
                  }}
                />
              </Form.Group>
            </Grid>
          )}

          {isDropdownVisible('exitOrderType') && (
            <Grid item>
              <Form.Group className="form-group">
                <label className="form-label">
                  Exit Order Type
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.exitOrderType}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Select aria-label="Default select example" name="exitOrderType" value={formData.exitOrderType || "Mkt protect"} onChange={(e) => handleFieldChange(e.target.value, "exitOrderType")}>
                  {exitOrderType.map((data, index) => {
                    return (
                      <option value={data} key={index}>{data}</option>
                    )
                  })
                  }
                </Form.Select>
              </Form.Group>

            </Grid>
          )}

          {formData.exitOrderType === "Mkt protect" && (isDropdownVisible('exitMarketProtect') || isDropdownVisible('exitOrderType')) && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("EMP")}
              onMouseEnter={(e) => handleCellHover("EMP")}
            >
              <Form.Group className={isError === "emp" ? "form-group error-border" : "form-group"}>
                <label className="form-label">
                  Exit Mkt Protect %
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.marketProtect}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                {/* <Form.Control type="number" placeholder="" step="1" name="marketProtect" min={1} value={formData.marketProtect} onChange={(e)=>handleFieldChange(e.target.value, "ordermarketProtectType")}/> */}
                <PlusMinQty
                  qtyClick={(qty, value) => {
                    seterror("")
                    handleFieldChange(qty, "exitmarketProtect")
                  }}
                  filterValue={formData.exitmarketProtect}
                  name={"exitmarketProtect"}
                  min={0}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                  title={

                    isError === "emp" ? "Exit Mkt Protect must be between 5% and 50%" : ""

                  }
                />
              </Form.Group>

            </Grid>
          )}

          {formData.exitOrderType === "Limit with buffer" && (isDropdownVisible('exitMarketBuffer') || isDropdownVisible('exitOrderType')) && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("EMB")}
              onMouseEnter={(e) => handleCellHover("EMB")}
            >
              <Form.Group className="form-group">
                <label className="form-label">
                  Exit Market Buffer %
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.limitWithBuffer}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <PlusMinQty
                  qtyClick={(qty, value) => {
                    handleFieldChange(qty, "exitmarketBuffer")
                  }}
                  filterValue={formData.exitmarketBuffer}
                  name={"exitmarketBuffer"}
                  min={1}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />
              </Form.Group>

            </Grid>
          )}
          {/* {isDropdownVisible('sendSlToBroker') && (
            <Grid item className="text-center">
              <div className="group-sq d-flex justify-content-center align-items-center " style={{ margin: "auto" }}>
                <Grid item className="text-center me-1">
                  <Typography style={{ fontSize: "11px" }}>Send SL to Broker </Typography>
                </Grid>
                <Grid item className="text-center">
                  <Switch
                    checked={formData.useBrokerSlTp}
                    onChange={(e) => handleSendSlToBrokerChange(e)}
                    size="small"
                  />
                </Grid>
              </div>
            </Grid>
          )} */}
          {isDropdownVisible('applyRmsToSellOnly') && (
            <Grid item className="text-center">
              <div className="group-sq d-flex justify-content-center align-items-center " style={{ margin: "auto" }}>
                <Grid item className="text-center me-1">
                  <Typography style={{ fontSize: "11px" }}>
                    Apply RMS to Sell Orders Only
                    <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.applyRmsToSellOnly}>
                      <Info size={12} className="info-icon" />
                    </Tooltip>
                  </Typography>
                </Grid>
                <Grid item className="text-center">
                  <Switch
                    checked={formData.applyRmsToSellOnly}
                    onChange={(e) => handleFieldBCChange(e, "applyRmsToSellOnly")}
                    size="small"
                  />
                </Grid>
              </div>
            </Grid>
          )}
          {formData.useBrokerSlTp && isDropdownVisible('brokerOrderType') &&
            <>
              <Grid item>
                <Form.Group className="form-group">
                  <label className="form-label">Order Type</label>
                  <Form.Select aria-label="Default select example" name="brokerSlTpOrderType" value={formData.brokerSlTpOrderType || "SL-L"} onChange={(e) => handleFieldBCChange(e.target.value, "brokerSlTpOrderType")}>
                    {defSLTP.map((data, index) => {
                      return (
                        <option value={data} key={index}>{data}</option>
                      )
                    })
                    }
                  </Form.Select>
                </Form.Group>

              </Grid>

              {formData.brokerSlTpOrderType === "SL-L" && isDropdownVisible('triggerPriceBuffer') && (
                <Grid
                  item
                  onMouseLeave={(e) => handleCellHoverLeave("SLTPOP")}
                  onMouseEnter={(e) => handleCellHover("SLTPOP")}
                  className="text-center">
                  <Form.Group className="form-group align-items-center d-flex " >
                    <label className="form-label">Trigger price buffer</label>
                    {/* <Form.Control type="number" placeholder="" step="1" name="stopLossPrice" min={1} value={formData.stopLossPrice}   onChange={handleFieldChange}/> */}
                    <PlusMinQty
                      qtyClick={(qty, value) => {
                        handleFieldBCChange(qty, "brokerSlTpOrderPercent")
                      }}
                      filterValue={formData.brokerSlTpOrderPercent}
                      name={"brokerSlTpOrderPercent"}
                      min={1}
                      step={1}
                      isModify={isModify}
                      page={"header"}
                    />
                  </Form.Group>
                </Grid>
              )}
            </>
          }
          {isDropdownVisible('waitXTicks') && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("CT")}
              onMouseEnter={(e) => handleCellHover("CT")}
            //onClick={() => editField("MP")}

            >
              <Form.Group className={isError === "wt" ? "form-group error-border" : "form-group"}>
                <label className="form-label">
                  Wait X ticks
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.waitXTicks}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>

                <PlusMinQty
                  qtyClick={(qty, value) => {
                    if (qty < 2) {
                      seterror("wt")
                      return
                    };
                    seterror("")
                    handleFieldBCChange(qty, "nConsecutiveTicks")
                  }}
                  filterValue={formData.nConsecutiveTicks}
                  name={"nConsecutiveTicks"}
                  min={1}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />

              </Form.Group>

            </Grid>
          )}
          {isDropdownVisible('strategyGrouping') && (
            <Grid item className="text-center">
              <div className="group-sq d-flex justify-content-center align-items-center " style={{ margin: "auto" }}>
                <Grid item className="text-center me-1 ">
                  <Typography style={{ fontSize: "11px", marginTop: "3px" }}>
                    Strategy Grouping
                    <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.strategyGrouping}>
                      <Info size={12} className="info-icon" />
                    </Tooltip>
                  </Typography>
                </Grid>
                <Grid item className="text-center">
                  <Switch
                    checked={strategygrouping}
                    onChange={(e) => {
                      setstrategygrouping(e);
                      setLocalStorageObject(
                        "global-bottom-other",
                        'strategygrouping',
                        e,
                        localStorageObjOther
                      );
                      dispatch(strategyGroupingAction(getLocalStorageObject("global-bottom-other")))
                    }}
                    size="small"
                  />
                </Grid>
              </div>
            </Grid>
          )}
          {isDropdownVisible('limitTimeoutAction') && (
            <Grid item>
              <Form.Group className="form-group">
                <label className="form-label">
                  Limit Timeout Action
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.limitTimeoutAction}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Select
                  aria-label="Default select example"
                  name="limitOrderTimeoutAction"
                  value={formData.limitOrderTimeoutAction == 0 ? "Do Nothing" : formData.limitOrderTimeoutAction == 1 ? "Convert to Market Order" : "Cancel"}
                  onChange={(e) => {

                    var val = 0;
                    if (e.target.value == "Do Nothing") {
                      val = 0;
                    } else if (e.target.value == "Convert to Market Order") {
                      val = 1;
                    } else {
                      val = 2;
                    }
                    handleFieldBCChange(val, "limitOrderTimeoutAction");
                  }}
                >
                  {defLimitTimeout.map((data, index) => {
                    return (
                      <option value={data} key={index}>{data}</option>
                    )
                  })
                  }
                </Form.Select>
              </Form.Group>

            </Grid>
          )}
          {isDropdownVisible('limitTimeoutSecs') && (
            <Grid
              item
              onMouseLeave={(e) => handleCellHoverLeave("LOTD")}
              onMouseEnter={(e) => handleCellHover("LOTD")}
              className="text-center">
              <Form.Group className="form-group" >
                <label className="form-label">
                  Limit Timeout Secs
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.limitTimeoutSecs}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <PlusMinQty
                  qtyClick={(qty, value) => {
                    handleFieldBCChange(parseFloat(qty), "limitOrderTimeoutDuration")
                  }}
                  filterValue={formData.limitOrderTimeoutDuration}
                  name={"limitOrderTimeoutDuration"}
                  min={null}
                  step={null}
                  isModify={isModify}
                  page={"header"}
                />
              </Form.Group>
            </Grid>
          )}
          {isDropdownVisible('entryExecutionMode') && (
            <Grid item>
              <Form.Group className="form-group">
                <label className="form-label">
                  Entry Execution Mode
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.executionMode}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Select
                  aria-label="Entry execution mode"
                  name="entryExecutionMode"
                  value={formData.entryExecutionMode}
                  onChange={(e) => handleFieldBCChange(e.target.value, "entryExecutionMode")}
                >
                  {defExecutionMode.map((data, index) => (
                    <option value={data} key={index}>
                      {data.charAt(0).toUpperCase() + data.slice(1)}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Grid>
          )}

          {isDropdownVisible('entryBuySellDelaySeconds') && formData.entryExecutionMode !== 'parallel' && (
            <Grid item className="text-center">
              <Form.Group className="form-group">
                <label className="form-label">
                  Entry Delay (Secs)
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.buySellDelay}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <PlusMinQty
                  qtyClick={(qty) => handleFieldBCChange(parseFloat(qty), "entryBuySellDelaySeconds")}
                  filterValue={formData.entryBuySellDelaySeconds}
                  name={"entryBuySellDelaySeconds"}
                  min={0}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />
              </Form.Group>
            </Grid>
          )}

          {isDropdownVisible('exitExecutionMode') && (
            <Grid item>
              <Form.Group className="form-group">
                <label className="form-label">
                  Exit Execution Mode
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.executionMode}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <Form.Select
                  aria-label="Exit execution mode"
                  name="exitExecutionMode"
                  value={formData.exitExecutionMode}
                  onChange={(e) => handleFieldBCChange(e.target.value, "exitExecutionMode")}
                >
                  {defExecutionMode.map((data, index) => (
                    <option value={data} key={index}>
                      {data.charAt(0).toUpperCase() + data.slice(1)}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Grid>
          )}

          {isDropdownVisible('exitBuySellDelaySeconds') && formData.exitExecutionMode !== 'parallel' && (
            <Grid item className="text-center">
              <Form.Group className="form-group">
                <label className="form-label">
                  Exit Delay (Secs)
                  <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.buySellDelay}>
                    <Info size={12} className="info-icon" />
                  </Tooltip>
                </label>
                <PlusMinQty
                  qtyClick={(qty) => handleFieldBCChange(parseFloat(qty), "exitBuySellDelaySeconds")}
                  filterValue={formData.exitBuySellDelaySeconds}
                  name={"exitBuySellDelaySeconds"}
                  min={0}
                  step={1}
                  isModify={isModify}
                  page={"header"}
                />
              </Form.Group>
            </Grid>
          )}
          {isDropdownVisible('allOrNothingEntry') && (
            <Grid item className="text-center">
              <div className="group-sq d-flex justify-content-center align-items-center " style={{ margin: "auto" }}>
                <Grid item className="text-center me-1">
                  <Typography style={{ fontSize: "11px" }}>
                    Exit on Margin Error(Entry)
                    <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.allOrNothing}>
                      <Info size={12} className="info-icon" />
                    </Tooltip>
                  </Typography>
                </Grid>
                <Grid item className="text-center">
                  <Switch
                    checked={formData.allOrNothingEntry}
                    onChange={(e) => {
                      handleFieldBCChange(e, "allOrNothingEntry");
                    }}
                    size="small"
                  />
                </Grid>
              </div>
            </Grid>
          )}
          {isDropdownVisible('allOrNothingExit') && (
            <Grid item className="text-center">
              <div className="group-sq d-flex justify-content-center align-items-center " style={{ margin: "auto" }}>
                <Grid item className="text-center me-1">
                  <Typography style={{ fontSize: "11px" }}>
                    Exit on Margin Error(Exit)
                    <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.allOrNothing}>
                      <Info size={12} className="info-icon" />
                    </Tooltip>
                  </Typography>
                </Grid>
                <Grid item className="text-center">
                  <Switch
                    checked={formData.allOrNothingExit}
                    onChange={(e) => {
                      handleFieldBCChange(e, "allOrNothingExit");
                    }}
                    size="small"
                  />
                </Grid>
              </div>
            </Grid>
          )}

          {isDropdownVisible('enableOrderWindow') && (
            <Grid item className="text-center">
              <div className="group-sq d-flex justify-content-center align-items-center " style={{ margin: "auto" }}>
                <Grid item className="text-center me-1">
                  <Typography style={{ fontSize: "11px" }}>
                    Enable Order Window
                    <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.enableOrderWindow}>
                      <Info size={12} className="info-icon" />
                    </Tooltip>
                  </Typography>
                </Grid>
                <Grid item className="text-center">
                  <Switch
                    checked={formData.enableOrderWindow}
                    onChange={(e) => {
                      const updatedValues = {
                        ...formData,
                        enableOrderWindow: e
                      };
                      setFormData(updatedValues);
                      setLocalStorageObject(
                        "global-bottom-other",
                        'enableOrderWindow',
                        e,
                        localStorageObjOther
                      );
                      getInputValues(updatedValues);
                    }}
                    size="small"
                  />
                </Grid>
              </div>
            </Grid>
          )}
        </Grid>

      </Card.Body>

      {/* Risk modals */}
      <LegRiskModal
        show={showLegRisk}
        setShow={setShowLegRisk}
        popUpData={formData}
        info={info}
        onSave={handleLegRiskSave}
      />
      <StrategyRiskModal
        show={showStrategyRisk}
        setShow={setShowStrategyRisk}
        popUpData={formData}
        info={info}
        onSave={handleStrategyRiskSave}
      />

      {/* Dropdown Visibility Configuration Modal */}
      <Modal show={showDropdownModal} onExit={() => setShowDropdownModal(false)} onHide={() => setShowDropdownModal(false)} size="xl">
        <Modal.Header>
          <Modal.Title>QuikTrade Configuration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="config-modal-container">
            <div className="config-modal-section">
              <h6 className={`${classes.sectionHeading} ${isDark ? classes.sectionHeadingDark : classes.sectionHeadingLight}`}>Default Order Attributes for 1 Click Execution</h6>
              <div className={classes.sectionContent}>
                {(() => {
                  const order = [
                    'product',
                    'validity',
                    'entryOrderType',
                    formData.orderType === "Mkt protect" ? 'entryMarketProtect' : '',
                    formData.orderType === "Limit with buffer" ? 'entryMarketBuffer' : '',
                    'maxLot',
                    'orderLot',
                    'exitOrderType',
                    formData.exitOrderType === "Mkt protect" ? 'exitMarketProtect' : '',
                    formData.exitOrderType === "Limit with buffer" ? 'exitMarketBuffer' : '',
                  ].filter(Boolean);
                  const items = tempDropdownVisibility
                    .filter(d => order.includes(d.id))
                    .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
                  return items.map((dropdown) => (
                    <div
                      key={dropdown.id}
                      className={classes.modalDropdownItem}
                      style={{ gridColumn: dropdown.id === "exitOrderType" ? '1' : '' }}
                      onMouseEnter={() => handleCellHover(dropdown.id)}
                      onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                    >
                      <div className="d-flex align-items-center">
                        <Checkbox
                          checked={dropdown.visible}
                          onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                        >
                          <div className="d-flex align-items-center">
                            {dropdown.id === 'entryMarketProtect' ? 'Entry Market Protect %' :
                              dropdown.id === 'exitMarketProtect' ? 'Exit Market Protect %' :
                                dropdown.id === 'entryMarketBuffer' ? 'Entry Limit Buffer %' :
                                  dropdown.id === 'exitMarketBuffer' ? 'Exit Market Buffer %' :
                                    dropdown.id === 'maxLot' ? 'Max (Lot) Qty per Order' :
                                      dropdown.id === 'orderLot' ? 'Order (Lot) Qty' : dropdown.label}
                            {(() => {
                              let helpKey = dropdown.id;
                              if (helpKey === 'entryOrderType' || helpKey === 'exitOrderType') helpKey = 'orderType';
                              if (helpKey === 'entryMarketProtect' || helpKey === 'exitMarketProtect') helpKey = 'marketProtect';
                              if (helpKey === 'entryMarketBuffer' || helpKey === 'exitMarketBuffer') helpKey = 'limitWithBuffer';
                              if (helpKey === 'maxLot') helpKey = 'maxQtyPerOrder';
                              if (helpKey === 'orderLot') helpKey = 'orderQty';

                              const content = helpText[helpKey];
                              if (content) {
                                return (
                                  <Tooltip overlayStyle={{ position: 'fixed' }} title={content}>
                                    <Info size={12} className="info-icon" />
                                  </Tooltip>
                                );
                              }
                              return null;
                            })()}
                          </div>
                        </Checkbox>
                      </div>
                      <div>
                        {dropdown.id === 'product' && (
                          <Form.Select value={formData.product || "MIS"} onChange={(e) => handleFieldChange(e.target.value, "product")}>
                            {defProduct.map((data, index) => (
                              <option value={data} key={index}>{data}</option>
                            ))}
                          </Form.Select>
                        )}
                        {dropdown.id === 'entryOrderType' && (
                          <Form.Select value={formData.orderType || "Mkt protect"} onChange={(e) => handleFieldChange(e.target.value, "orderType")}>
                            {defOrderType.map((data, index) => {
                              return (
                                <option value={data} key={index}>{data}</option>
                              )
                            })}
                          </Form.Select>
                        )}
                        {dropdown.id === 'entryMarketProtect' && (
                          <PlusMinQty
                            qtyClick={(qty, value) => handleFieldChange(qty, "marketProtect")}
                            filterValue={formData.marketProtect}
                            name={"marketProtect"}
                            min={0}
                            step={1}
                            isModify={isModify}
                            page={"header"}
                          />
                        )}
                        {dropdown.id === 'entryMarketBuffer' && (
                          <PlusMinQty
                            qtyClick={(qty, value) => handleFieldChange(qty, "marketBuffer")}
                            filterValue={formData.marketBuffer}
                            name={"marketBuffer"}
                            min={1}
                            step={1}
                            isModify={isModify}
                            page={"header"}
                          />
                        )}
                        {dropdown.id === 'exitOrderType' && (
                          <Form.Select value={formData.exitOrderType || "Mkt protect"} onChange={(e) => handleFieldChange(e.target.value, "exitOrderType")}>
                            {exitOrderType.map((data, index) => {
                              return (
                                <option value={data} key={index}>{data}</option>
                              )
                            })}
                          </Form.Select>
                        )}
                        {dropdown.id === 'exitMarketProtect' && formData.exitOrderType === "Mkt protect" && (
                          <PlusMinQty
                            qtyClick={(qty, value) => {
                              seterror("")
                              handleFieldChange(qty, "exitmarketProtect")
                            }}
                            filterValue={formData.exitmarketProtect}
                            name={"exitmarketProtect"}
                            min={0}
                            step={1}
                            isModify={isModify}
                            page={"header"}
                            title={isError === "emp" ? "Exit Mkt Protect must be between 5% and 50%" : ""}
                          />
                        )}
                        {dropdown.id === 'exitMarketBuffer' && formData.exitOrderType === "Limit with buffer" && (
                          <PlusMinQty
                            qtyClick={(qty, value) => handleFieldChange(qty, "exitmarketBuffer")}
                            filterValue={formData.exitmarketBuffer}
                            name={"exitmarketBuffer"}
                            min={1}
                            step={1}
                            isModify={isModify}
                            page={"header"}
                          />
                        )}
                        {dropdown.id === 'maxLot' && (
                          <PlusMinQty
                            qtyClick={(qty, value) => {
                              if (info.volumeFreeze == 0) {
                                if ((qty * info.lotSize) > 50 * info.lotSize) {
                                  return false
                                } else {
                                  handleFieldChange(qty, "freezeQty")
                                }
                              } else {
                                if ((qty * info.lotSize) > info.volumeFreeze) {
                                  return
                                } else {
                                  handleFieldChange(qty, "freezeQty")
                                }
                              }
                            }}
                            filterValue={formData.freezeQty}
                            name={"freezeQty"}
                            min={1}
                            step={1}
                            max={info.volumeFreeze == 0 ? 50 : info.volumeFreeze / info.lotSize}
                            isModify={isModify}
                            page={"header"}
                          />
                        )}
                        {dropdown.id === 'orderLot' && (
                          <PlusMinQty
                            qtyClick={(qty, value) => {
                              if (qty > 0) {
                                handleFieldChange(qty, "orderQty")
                              }
                            }}
                            filterValue={formData.orderQty}
                            name={"orderQty"}
                            min={1}
                            step={1}
                            isModify={isModify}
                            page={"header"}
                          />
                        )}
                        {dropdown.id === 'validity' && (
                          <Form.Select value={formData.validity || "DAY"} onChange={(e) => handleFieldChange(e.target.value, "validity")}>
                            {defValidity.map((data, index) => (
                              <option value={data} key={index}>{data}</option>
                            ))}
                          </Form.Select>
                        )}
                      </div>
                    </div>
                  ))
                })()}
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <div className="config-modal-section">
              <div className={classes.modalSection}>
                <div className={classes.sectionContent}>
                  {tempDropdownVisibility.filter(d => ['stopLoss', 'target', 'trailingSL'].includes(d.id)).map((dropdown) => (
                    <div
                      key={dropdown.id}
                      className={classes.modalDropdownItem}
                      onMouseEnter={() => handleCellHover(dropdown.id)}
                      onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                    >
                      <div className="d-flex align-items-center">
                        <Checkbox
                          checked={dropdown.visible}
                          onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                        >
                          {dropdown.label}
                        </Checkbox>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className={classes.modalSection}>
                <h6 className={`${classes.sectionHeading} ${isDark ? classes.sectionHeadingDark : classes.sectionHeadingLight}`}>RMS Limits</h6>
                <div className={classes.sectionContent}>
                  {tempDropdownVisibility.filter(d => ['rmsMaxLoss', 'rmsMaxProfit'].includes(d.id)).map((dropdown) => (
                    <div
                      key={dropdown.id}
                      className={classes.modalDropdownItem}
                      onMouseEnter={() => handleCellHover(dropdown.id)}
                      onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                    >
                      <div className="d-flex align-items-center">
                        <Checkbox
                          checked={dropdown.visible}
                          onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                        >
                          <div className="d-flex align-items-center">
                            {dropdown.id === 'rmsMaxLoss' ? 'RMS Stoploss' : 'RMS Target'}
                            <Tooltip overlayStyle={{ position: 'fixed' }} title={dropdown.id === 'rmsMaxLoss' ? helpText.rmsMaxLoss : helpText.rmsMaxProfit}>
                              <Info size={12} className="info-icon" />
                            </Tooltip>
                          </div>
                        </Checkbox>
                      </div>
                      <div>
                        {dropdown.id === 'rmsMaxLoss' && (
                          <PlusMinQty
                            qtyClick={(qty, value) => handleFieldBCChange(parseFloat(qty), "maxLoss")}
                            filterValue={formData.maxLoss ?? ""}
                            name={"maxLoss"}
                            min={null}
                            step={null}
                            isModify={isModify}
                            page={"header"}
                          />
                        )}
                        {dropdown.id === 'rmsMaxProfit' && (
                          <PlusMinQty
                            qtyClick={(qty, value) => handleFieldBCChange(parseFloat(qty), "maxProfit")}
                            filterValue={formData.maxProfit ?? ""}
                            name={"maxProfit"}
                            min={0}
                            step={1}
                            isModify={isModify}
                            page={"header"}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              </div>

              <div className="config-modal-section">
              <div className={classes.modalSection}>
                <h6 className={`${classes.sectionHeading} ${isDark ? classes.sectionHeadingDark : classes.sectionHeadingLight}`}>Multi Leg Execution Settings</h6>
                <div className={classes.sectionContent}>
                  {tempDropdownVisibility.filter(d => ['entryExecutionMode', 'entryBuySellDelaySeconds', 'allOrNothingEntry', 'exitExecutionMode', 'exitBuySellDelaySeconds', 'allOrNothingExit'].includes(d.id)).map((dropdown) => {
                    if ((dropdown.id === 'entryBuySellDelaySeconds' && formData.entryExecutionMode === 'parallel') ||
                      (dropdown.id === 'exitBuySellDelaySeconds' && formData.exitExecutionMode === 'parallel')) {
                      return null;
                    }

                    return (
                      <div
                        key={dropdown.id}
                        className={classes.modalDropdownItem}
                        onMouseEnter={() => handleCellHover(dropdown.id)}
                        onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                      >
                        <div className="d-flex align-items-center">
                          <Checkbox
                            checked={dropdown.visible}
                            onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                          >
                            <div className="d-flex align-items-center">
                              {dropdown.label}
                              <Tooltip 
                                overlayStyle={{ position: 'fixed' }} 
                                title={
                                  ['entryExecutionMode', 'exitExecutionMode'].includes(dropdown.id) 
                                    ? helpText.executionMode 
                                    : ['allOrNothingEntry', 'allOrNothingExit'].includes(dropdown.id)
                                      ? helpText.allOrNothing
                                      : helpText.buySellDelay
                                }
                              >
                                <Info size={12} className="info-icon" />
                              </Tooltip>
                            </div>
                          </Checkbox>
                        </div>
                        <div>
                          {['entryExecutionMode', 'exitExecutionMode'].includes(dropdown.id) && (
                            <Form.Select
                              value={formData[dropdown.id]}
                              onChange={(e) => handleFieldBCChange(e.target.value, dropdown.id)}
                            >
                              {defExecutionMode.map((data, index) => (
                                <option value={data} key={index}>
                                  {data.charAt(0).toUpperCase() + data.slice(1)}
                                </option>
                              ))}
                            </Form.Select>
                          )}
                          {['entryBuySellDelaySeconds', 'exitBuySellDelaySeconds'].includes(dropdown.id) && (
                            <PlusMinQty
                              qtyClick={(qty) => handleFieldBCChange(parseFloat(qty), dropdown.id)}
                              filterValue={formData[dropdown.id]}
                              name={dropdown.id}
                              min={0}
                              step={1}
                              isModify={isModify}
                              page={"header"}
                            />
                          )}
                          {['allOrNothingEntry', 'allOrNothingExit'].includes(dropdown.id) && (
                            <Switch
                              checked={formData[dropdown.id]}
                              onChange={(e) => handleFieldBCChange(e, dropdown.id)}
                              size="small"
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            </div>

            {/* Others*/}
            <div className="config-modal-section">
              <h6 className={`${classes.sectionHeading} ${isDark ? classes.sectionHeadingDark : classes.sectionHeadingLight}`}>Miscellaneous Settings</h6>
              <div style={{ display: "flex", columnGap: "40px", rowGap: "10px", flexWrap: "wrap" }}>
                {/* Wait X Ticks */}
                {tempDropdownVisibility.filter(d => ['waitXTicks'].includes(d.id)).map((dropdown) => (
                  <div
                    key={dropdown.id}
                    className={classes.modalDropdownItem}
                    onMouseEnter={() => handleCellHover(dropdown.id)}
                    onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                  >
                    <div className="d-flex align-items-center">
                      <Checkbox
                        checked={dropdown.visible}
                        onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                      >
                        <div className="d-flex align-items-center">
                          Wait X ticks
                          <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.waitXTicks}>
                            <Info size={12} className="info-icon" />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </div>
                    <div>
                      <PlusMinQty
                        qtyClick={(qty, value) => {
                          if (qty < 2) {
                            seterror("wt")
                            return
                          }
                          seterror("")
                          handleFieldBCChange(qty, "nConsecutiveTicks")
                        }}
                        filterValue={formData.nConsecutiveTicks}
                        name={"nConsecutiveTicks"}
                        min={1}
                        step={1}
                        isModify={isModify}
                        page={"header"}
                      />
                    </div>
                  </div>
                ))}

                {/* Limit Timeout Action and Seconds */}
                {tempDropdownVisibility.filter(d => ['limitTimeoutAction', 'limitTimeoutSecs'].includes(d.id)).map((dropdown) => (
                  <div
                    key={dropdown.id}
                    className={classes.modalDropdownItem}
                    onMouseEnter={() => handleCellHover(dropdown.id)}
                    onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                  >
                    <div className="d-flex align-items-center">
                      <Checkbox
                        checked={dropdown.visible}
                        onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                      >
                        <div className="d-flex align-items-center">
                          {dropdown.id === 'limitTimeoutSecs' ? 'Limit Timeout Seconds' : dropdown.label}
                          <Tooltip overlayStyle={{ position: 'fixed' }} title={dropdown.id === 'limitTimeoutSecs' ? helpText.limitTimeoutSecs : helpText.limitTimeoutAction}>
                            <Info size={12} className="info-icon" />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </div>
                    <div>
                      {dropdown.id === 'limitTimeoutAction' && (
                        <Form.Select

                          value={formData.limitOrderTimeoutAction == 0 ? "Do Nothing" : formData.limitOrderTimeoutAction == 1 ? "Convert to Market Order" : "Cancel"}
                          onChange={(e) => {
                            var val = 0;
                            if (e.target.value == "Do Nothing") {
                              val = 0;
                            } else if (e.target.value == "Convert to Market Order") {
                              val = 1;
                            } else {
                              val = 2;
                            }
                            handleFieldBCChange(val, "limitOrderTimeoutAction");
                          }}
                        >
                          {defLimitTimeout.map((data, index) => (
                            <option value={data} key={index}>{data}</option>
                          ))}
                        </Form.Select>
                      )}
                      {dropdown.id === 'limitTimeoutSecs' && (
                        <PlusMinQty
                          qtyClick={(qty, value) => handleFieldBCChange(parseFloat(qty), "limitOrderTimeoutDuration")}
                          filterValue={formData.limitOrderTimeoutDuration}
                          name={"limitOrderTimeoutDuration"}
                          min={null}
                          step={null}
                          isModify={isModify}
                          page={"header"}
                        />
                      )}
                    </div>
                  </div>
                ))}

                {/* Auto Square Off */}
                {tempDropdownVisibility.filter(d => ['autoSquareOff'].includes(d.id)).map((dropdown) => (
                  <div
                    key={dropdown.id}
                    className={classes.modalDropdownItem}
                    onMouseEnter={() => handleCellHover(dropdown.id)}
                    onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                  >
                    <div className="d-flex align-items-center">
                      <Checkbox
                        checked={dropdown.visible}
                        onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                      >
                        <div className="d-flex align-items-center">
                          {dropdown.label}
                          <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.autoSquareOff}>
                            <Info size={12} className="info-icon" />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </div>
                    <div>
                      <Form.Control
                        type="time"
                        name="autoSquareOffTime"
                        value={formData.autoSquareOffTime || "15:20"}
                        onChange={(e) => handleFieldBCChange(e.target.value, "autoSquareOffTime")}
                        style={{
                          width: "94px",
                          paddingRight: "0",
                          paddingLeft: "10px"
                        }}
                      />
                    </div>
                  </div>
                ))}

                {/* Strategy Grouping */}
                {tempDropdownVisibility.filter(d => ['strategyGrouping'].includes(d.id)).map((dropdown) => (
                  <div
                    key={dropdown.id}
                    className={classes.modalDropdownItem}
                    onMouseEnter={() => handleCellHover(dropdown.id)}
                    onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                  >
                    <div className="d-flex align-items-center">
                      <Checkbox
                        checked={dropdown.visible}
                        onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                      >
                        <div className="d-flex align-items-center">
                          Strategy Grouping
                          <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.strategyGrouping}>
                            <Info size={12} className="info-icon" />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </div>
                    <div>
                      <Switch
                        checked={strategygrouping}
                        onChange={(e) => {
                          setstrategygrouping(e);
                          setLocalStorageObject(
                            "global-bottom-other",
                            'strategygrouping',
                            e,
                            localStorageObjOther
                          );
                          dispatch(strategyGroupingAction(getLocalStorageObject("global-bottom-other")))
                        }}
                        size="small"
                      />
                    </div>
                  </div>
                ))}

                {/* Enable Order Window */}
                {tempDropdownVisibility.filter(d => ['enableOrderWindow'].includes(d.id)).map((dropdown) => (
                  <div
                    key={dropdown.id}
                    className={classes.modalDropdownItem}
                    onMouseEnter={() => handleCellHover(dropdown.id)}
                    onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                  >
                    <div className="d-flex align-items-center">
                      <Checkbox
                        checked={dropdown.visible}
                        onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                      >
                        <div className="d-flex align-items-center">
                          Enable Order Window
                          <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.enableOrderWindow}>
                            <Info size={12} className="info-icon" />
                          </Tooltip>
                        </div>
                      </Checkbox>
                    </div>
                    <div>
                      <Switch
                        checked={formData.enableOrderWindow}
                        onChange={(e) => {
                          const updatedValues = {
                            ...formData,
                            enableOrderWindow: e
                          };
                          setFormData(updatedValues);
                          setLocalStorageObject(
                            "global-bottom-other",
                            'enableOrderWindow',
                            e,
                            localStorageObjOther
                          );
                          getInputValues(updatedValues);
                        }}
                        size="small"
                      />
                    </div>
                  </div>
                ))}




                {/* Existing Others fields */}
                {tempDropdownVisibility.filter(d => ['applyRmsToSellOnly', formData.useBrokerSlTp ? 'brokerOrderType' : '', formData.useBrokerSlTp ? 'triggerPriceBuffer' : ''].includes(d.id)).map((dropdown) => (
                  <div
                    key={dropdown.id}
                    className={classes.modalDropdownItem}
                    onMouseEnter={() => handleCellHover(dropdown.id)}
                    onMouseLeave={() => handleCellHoverLeave(dropdown.id)}
                  >
                    <div className="d-flex align-items-center">
                      <Checkbox
                        checked={dropdown.visible}
                        onChange={(e) => handleDropdownVisibilityChange(dropdown.id, e.target.checked)}
                      >
                        <div className="d-flex align-items-center">
                          {dropdown.id === 'brokerOrderType' ? 'Order Type' :
                            dropdown.id === 'triggerPriceBuffer' ? 'Trigger Price Buffer' : dropdown.label}
                          {(() => {
                            let helpKey = dropdown.id;
                            if (helpKey === 'applyRmsToSellOnly') {
                              return (
                                <Tooltip overlayStyle={{ position: 'fixed' }} title={helpText.applyRmsToSellOnly}>
                                  <Info size={12} className="info-icon" />
                                </Tooltip>
                              );
                            }
                            return null;
                          })()}
                        </div>
                      </Checkbox>
                    </div>

                    <div>
                      {dropdown.id === 'sendSlToBroker' && (
                        <Switch
                          checked={formData.useBrokerSlTp}
                          onChange={(e) => handleFieldBCChange(e, "useBrokerSlTp")}
                          size="small"
                        />
                      )}
                      {dropdown.id === 'applyRmsToSellOnly' && (
                        <Switch
                          checked={formData.applyRmsToSellOnly}
                          onChange={(e) => handleFieldBCChange(e, "applyRmsToSellOnly")}
                          size="small"
                        />
                      )}
                      {dropdown.id === 'brokerOrderType' && (
                        <Form.Select value={formData.brokerSlTpOrderType || "SL-L"} onChange={(e) => handleFieldBCChange(e.target.value, "brokerSlTpOrderType")}>
                          {defSLTP.map((data, index) => (
                            <option value={data} key={index}>{data}</option>
                          ))}
                        </Form.Select>
                      )}
                      {dropdown.id === 'triggerPriceBuffer' && (
                        <PlusMinQty
                          qtyClick={(qty, value) => handleFieldBCChange(qty, "brokerSlTpOrderPercent")}
                          filterValue={formData.brokerSlTpOrderPercent}
                          name={"brokerSlTpOrderPercent"}
                          min={1}
                          step={1}
                          isModify={isModify}
                          page={"header"}
                        />
                      )}
                    </div>
                  </div>
                ))}


              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={handleSelectAll}
            className="me-2"
            style={{ height: "36px" }}
          >
            Select All
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleDeselectAll}
            style={{ height: "36px" }}
            className="me-2"
          >
            Deselect All
          </Button>
          <Button variant="primary" onClick={saveDropdownConfig}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* SL Type Information Modal */}
      <AntModal
        title="Send SL to Broker - Important Information"
        open={showSlInfoModal}
        onOk={handleSlInfoModalOk}
        onCancel={handleSlInfoModalCancel}
        okText="I Understand"
        centered
      >
        <div style={{ padding: '10px 0' }}>
          <p style={{ marginBottom: '15px', fontSize: '14px' }}>
            <strong>Please Note:</strong>
          </p>
          <p style={{ marginBottom: '10px', fontSize: '14px' }}>
            When you enable <strong>Send SL to Broker</strong>, the Stop Loss (SL) order will be sent to the broker
            <strong> only when the SL/TP Basis is set to Price</strong>.
          </p>
          <p style={{ marginBottom: '10px', fontSize: '14px' }}>
            If the SL/TP Basis is set to <strong>PNL</strong>, the SL/TP will <strong>NOT</strong> be sent to the broker.
          </p>
          <p style={{ marginBottom: '0', fontSize: '14px' }}>Also note that when this setting is enabled, risk management at the QuikTrade app level will be switched off. In the future, we plan to bring the best of both worlds.</p>
        </div>
      </AntModal>

      {/* Max Lot Info Modal */}
      <AntModal
        title="Max Lot Qty - Important Information"
        open={showMaxLotInfoModal}
        onOk={() => setShowMaxLotInfoModal(false)}
        onCancel={() => setShowMaxLotInfoModal(false)}
        okText="I Understand"
        centered
      >
        <div style={{ padding: '10px 0' }}>
          <p style={{ marginBottom: '15px', fontSize: '14px' }}>
            This setting is used to control the maximum quantity per single order. Be careful when setting this to a lower number, as it will result in a higher number of orders being placed.
          </p>
          <p style={{ marginBottom: '10px', fontSize: '14px' }}>
            For example:
          </p>
          <ul style={{ marginBottom: '15px', fontSize: '14px', paddingLeft: '20px' }}>
            <li>If Max Lot = 1 and Order Lot = 10, then 10 ÷ 1 results in 10 orders, each with 1 lot.</li>
            <li>If Max Lot = 10 and Order Lot = 35, then 4 orders will be placed with quantities of 10, 10, 10, and 5 lots respectively.</li>
          </ul>
          <p style={{ marginBottom: '0', fontSize: '14px' }}>
            <strong>Please note:</strong> The broker API has a maximum order limit of 10 orders per second.
          </p>
        </div>
      </AntModal>
    </div>
  );
};

export default HeaderDropdown;
